import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./ErpN.css";

import AccountDashboard from "../../assets/DashboardImages/accountDashboard.png";
import adminDashboard from "../../assets/DashboardImages/adminDashboard.png";
import chairmanDashboard from "../../assets/DashboardImages/chairmanDashboard.png";
import hostelDashboard from "../../assets/DashboardImages/hostelDashboard.png";
import libraryDashboard from "../../assets/DashboardImages/libraryDashboard.png";
import placementDashboard from "../../assets/DashboardImages/placementsDashboard.png";
import principalDashboard from "../../assets/DashboardImages/principalDashboard.png";
import StudentDashboard from "../../assets/DashboardImages/studentDashboard.jpg";
import Inventory from "../../assets/ALumni_sliderImgs/inventory.png";
import inventory_invoice from "../../assets/ALumni_sliderImgs/inventory-invoice.png";
import inventory_Payments from "../../assets/ALumni_sliderImgs/inventory-payments.png";
import InventoryPurchaseOrders from "../../assets/ALumni_sliderImgs/inventory-purchase-Orders.png";
import InveinventorySalesOrder from "../../assets/ALumni_sliderImgs/inventory-sales-order.png";

const AdhikritErpInterface = () => {
  return (
    <div className="erp-interface-container">
      <form>
        <fieldset className="erp-fieldset">
          <legend className="erp-legend">Adhikrit ERP Interface</legend>

          <button className="swiper-button swiper-button-prev"></button>
          <button className="swiper-button swiper-button-next"></button>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
          >
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Principal Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={principalDashboard}
                  alt="Principal Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Library Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={libraryDashboard}
                  alt="Library Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Placement Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={placementDashboard}
                  alt="Placement Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Chairman Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={chairmanDashboard}
                  alt="Chairman Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Admin Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={adminDashboard}
                  alt="Admin Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Student Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={StudentDashboard}
                  alt="Student Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Account Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={AccountDashboard}
                  alt="Account Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Hostel Dashboard</h4>
                <img
                  className="dashboard-image"
                  src={hostelDashboard}
                  alt="Hostel Dashboard"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Inventory</h4>
                <img
                  className="dashboard-image"
                  src={Inventory}
                  alt="Inventory"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Inventory Invoice</h4>
                <img
                  className="dashboard-image"
                  src={inventory_invoice}
                  alt="Inventory Invoice"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Inventory Payments</h4>
                <img
                  className="dashboard-image"
                  src={inventory_Payments}
                  alt="Inventory Payments"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Inventory Purchase Orders</h4>
                <img
                  className="dashboard-image"
                  src={InventoryPurchaseOrders}
                  alt="Inventory Purchase Orders"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="erp-slide">
                <h4 className="dashboard-title">Inventory Sales Order</h4>
                <img
                  className="dashboard-image"
                  src={InveinventorySalesOrder}
                  alt="Inventory Sales Order"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </fieldset>
      </form>
    </div>
  );
};

export default AdhikritErpInterface;
